/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FacilityStatusReportDto } from '../../models/facility-status-report-dto';
import { FacilityStatusReportUpdateDto } from '../../models/facility-status-report-update-dto';

export interface UpdateFacilityStatusReport$Params {
  facilityStatusReportId: number;
      body: FacilityStatusReportUpdateDto
}

export function updateFacilityStatusReport(http: HttpClient, rootUrl: string, params: UpdateFacilityStatusReport$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityStatusReportDto>> {
  const rb = new RequestBuilder(rootUrl, updateFacilityStatusReport.PATH, 'put');
  if (params) {
    rb.path('facilityStatusReportId', params.facilityStatusReportId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FacilityStatusReportDto>;
    })
  );
}

updateFacilityStatusReport.PATH = '/api/facilitystatusreport/{facilityStatusReportId}';
